import type { IconProps } from '@ui/components/Icon/Icon';
import { MantineColor, Loader } from '@mantine/core';
import { useMemo } from 'react';
import IconButton from '@ui/components/IconButton/IconButton';
import Icon from '@ui/components/Icon/Icon';
import type { BackgroundTask, BackgroundTaskStatus } from '../../../models/BackgroundTask';

const ICONS_BY_STATUS: Record<BackgroundTaskStatus, IconProps['icon']> = {
	unknown: 'clear',
	processing: 'clear',
	successful: 'check_circle',
	partially_successful: 'error',
	failed: 'error',
	canceled: 'remove_circle'
};

type BackgroundTaskStatusIndicatorProps = {
	backgroundTask: BackgroundTask,
	testID?: string,
	color: MantineColor
};

const BackgroundTaskStatusIndicator = ( {
	backgroundTask, testID, color
}: BackgroundTaskStatusIndicatorProps ) => {
	const icon = useMemo( () => ICONS_BY_STATUS[ backgroundTask.status ], [ backgroundTask.status ] );

	if ( backgroundTask.hasFinished ) {
		return (
			<Icon icon={icon} size={16} color={color} />
		);
	}

	return backgroundTask.cancelable ? (
		<IconButton
			icon="clear"
			size={16}
			color="space.7"
			onClick={() => backgroundTask.cancel()}
			data-testid={`${testID}-cancel-button`}
		/>
	) : <Loader size="16px" />;
};

export default BackgroundTaskStatusIndicator;
